import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "./ui/Button";
import ToastItem from "./ToastItem";
import { useTicketContext } from "../context/TicketContext";

const CompleteWorkflowModal = () => {
  const navigate = useNavigate();
  const { ticket, completeWorkFlow } = useTicketContext();
  const [comment, setComment] = useState("");
  const [toastMessage, setToastMessage] = useState("");
  const [withSpsError, setWithSpsError] = useState("");
  const [spsReason, setSpsReason] = useState("");
  const feedback_workflowtype = "SPS Feedback"
  const handleCompleteWorkflow = async () => {
    try {
      if (!comment) {
        setToastMessage("Comments are required");
        return;
      }

      // For SPS Rescan/Pull Request type, check the additional mandatory dropdowns.
      if (ticket?.workflowtype === feedback_workflowtype) {
        if (!withSpsError) {
          setToastMessage("Please select With SPS Error");
          return;
        }
        if (!spsReason) {
          setToastMessage("Please select Reason");
          return;
        }
      }

      // Complete the workflow once all validations pass.
      let resp = await completeWorkFlow("", "Completed", comment, false, {"spsError":withSpsError, "reason": spsReason});
      if (resp !== "0") navigate("/manage-ticket?page=1");
    } catch (error) {
      console.log("### Error while completing the workflow #####");
    }
  };

  return (
    <div className="my-10">
      {/* Any toast/error message */}
      {toastMessage && (
        <ToastItem
          key="index"
          keyPrefix="lineItems"
          item={toastMessage}
          index="index"
          onRemove={() => setToastMessage("")}
        />
      )}

      <h1 className="font-28-42-400">Complete Workflow</h1>

      {/* Back link */}
      <p
        className="font-18-400-24 flex items-center gap-2 cursor-pointer"
        onClick={() => navigate(-1)}
      >
        <img className="size-13 rotate--90" src="/Vector.svg" alt="Back" />
        Back
      </p>

      {/* Show SPS Error / Reason side by side ONLY if it's SPS Rescan/Pull Request */}
      {ticket?.workflowtype === feedback_workflowtype && (
        <div className="flex flex-col md:flex-row md:items-end gap-4 mt-4">
          {/* Left column: With SPS Error */}
          <div className="flex-1">
            <label className="block font-18-400-24 mb-1" htmlFor="withSpsError">
              With SPS Error:
            </label>
            <div className="relative w-full">
              <select
                id="withSpsError"
                className="
                  no-native-arrow
                  block w-full border border-gray-300 rounded
                  py-2 px-3 pr-8
                  text-gray-700 bg-white
                  focus:outline-none focus:ring-2 focus:ring-indigo-500
                  cursor-pointer
                "
                style={{ fontSize: "12px", lineHeight: "1.2" }}
                value={withSpsError}
                onChange={(e) => setWithSpsError(e.target.value)}
              >
                <option value="">Select option</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
              {/* Custom Arrow Icon */}
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-600">
                <svg
                  className="h-4 w-4 fill-current"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M7 7l3-3 3 3M7 13l3 3 3-3" />
                </svg>
              </div>
            </div>
          </div>

          {/* Right column: Reason */}
          <div className="flex-1">
            <label className="block font-18-400-24 mb-1" htmlFor="spsReason">
              Reason:
            </label>
            <div className="relative w-full">
              <select
                id="spsReason"
                className="
                  no-native-arrow
                  block w-full border border-gray-300 rounded
                  py-2 px-3 pr-8
                  text-gray-700 bg-white
                  focus:outline-none focus:ring-2 focus:ring-indigo-500
                  cursor-pointer
                "
                style={{ fontSize: "12px", lineHeight: "1.2" }}
                value={spsReason}
                onChange={(e) => setSpsReason(e.target.value)}
              >
                <option value="">Select reason</option>
                <option value="Indexing Error">Indexing Error</option>
                <option value="Business Rule">Business Rule</option>
                <option value="Other">Other</option>
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-600">
                <svg
                  className="h-4 w-4 fill-current"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M7 7l3-3 3 3M7 13l3 3 3-3" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Closing comments - now AFTER the dropdowns */}
      <p className="font-18-400-24 mt-4">Closing comments:</p>
      <textarea
        className="w-full h-32 p-2 border border-gray-300 rounded"
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        placeholder="Enter Comments"
      ></textarea>

      {/* Complete button */}
      <div className="mt-4">
        <Button
          className="border-none h-42 font-16-700 w-135 capitalize justify-center br-4 create-btn px-8 text-sm font-semibold text-white"
          onClick={handleCompleteWorkflow}
        >
          Complete
        </Button>
      </div>
    </div>
  );
};

export default CompleteWorkflowModal;
